import { ContentType } from './types';
export const downloadOptionToContentType = {
  pdf: ContentType.PDF,
  xlsx: ContentType.XLSX
};